import { c as _c } from "react/compiler-runtime";
import { TabMenu, TabMenuItem, TabMenuItemTitle, Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { isSolanaAddress } from "../../../../lib/address";
export const VIEW_WALLET_TABS = ["crypto", "nfts"];
export function ViewWalletTabMenu(t0) {
  const $ = _c(17);
  const {
    address,
    activeTab,
    switchTab
  } = t0;
  const t = useTranslations("wallet.ViewWalletTabMenu");
  let t1;
  if ($[0] !== t) {
    t1 = t("tokensTab");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("collectionsTab");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      crypto: t1,
      nfts: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const tabNames = t3;
  let t4;
  if ($[7] !== address) {
    t4 = isSolanaAddress(address);
    $[7] = address;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const isSVM = t4;
  let t5;
  if ($[9] !== activeTab || $[10] !== isSVM || $[11] !== switchTab || $[12] !== t || $[13] !== tabNames) {
    t5 = VIEW_WALLET_TABS.map(tab => {
      const isDisabled = isSVM && tab === "nfts";
      return <Tooltip content={t("comingSoon")} disabled={!isDisabled} key={tab} side="bottom"><div className="flex w-full lg:w-auto"><TabMenuItem active={tab === activeTab} className="mx-0 flex-1 justify-center text-sm lg:grow-0" disabled={isDisabled} onClick={switchTab.bind(undefined, tab)}><TabMenuItemTitle>{tabNames[tab]}</TabMenuItemTitle></TabMenuItem></div></Tooltip>;
    });
    $[9] = activeTab;
    $[10] = isSVM;
    $[11] = switchTab;
    $[12] = t;
    $[13] = tabNames;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <TabMenu className="-mt-2 border-border-1 border-b px-4 lg:mt-0 lg:px-6">{t5}</TabMenu>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}